module.exports = __webpack_public_path__ + "media/univerahealthcare-perks@xs-db9dbed9009e300338ed16044db4126c.jpg";